export default __webpack_public_path__ + "static/media/dani-f-u.85fe717b.jpeg";